import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef } from "vue";
const _hoisted_1 = ["innerHTML"];

const _hoisted_2 = /*#__PURE__*/_createTextVNode("全部团队");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("部分团队");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加团队");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("是");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("否");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("保存并发布");

import { ref, computed, watch, nextTick } from 'vue';
import { getVexTableProps } from '@/config';
import { arrayRemoveRepeatByProp } from '@/utils';
import { saveNotice, getNoticeDetail } from '@/request';
import { ElMessage } from 'element-plus';
import AddTeamModal from '@/components/AddTeamModal.vue';
import Editor from './Editor.vue';
import AddPersonModal from './AddPersonModal.vue';
export default {
  name: 'AddPlatformNoticeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    see: {
      type: Boolean,
      default: false
    },
    noticeTypeList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const formRef = ref();
    const table = ref();
    const defaultForm = {
      author: '',
      content: '',
      isOpenMessageNotification: 0,
      receiveRange: 1,
      status: '',
      supInformationTypeId: '',
      title: ''
    };
    const showAddTeamModal = ref(false);
    const showAddPersonModal = ref(false);
    const tableData = ref([]);
    watch(() => tableData.value, newVal => {
      var _table$value, _table$value2;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.loadData(newVal);
      console.log((_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.getData(0));
    });
    const form = ref(_objectSpread({}, defaultForm));
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const scroll = ref();
    const tableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '团队名称',
        field: 'supplier_name',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员数量',
        field: 'salesman_num'
      }, {
        title: '联系人',
        field: 'link_man'
      }, {
        title: '联系电话',
        field: 'link_phone'
      }, {
        title: '业务区域',
        field: 'businessAreaName',
        showOverflow: true
      }]
    };

    function initEditData() {
      // 编辑或查看的时候初始化信息
      getNoticeDetail({
        id: props.editData.supInformationId,
        operate: 'edit'
      }).then(data => {
        if (data.success) {
          var _data$data$informatio;

          form.value.content = data.data.information.content; // 格式化数据 保证 添加团队 添加人员和查询的信息 格式保持一致

          tableData.value = (_data$data$informatio = data.data.information.receiverList) === null || _data$data$informatio === void 0 ? void 0 : _data$data$informatio.map(i => {
            i.supplier_name = i.supplierName;
            i.salesmanAreaName = i.businessAreaName;

            if (i.type === 1) {
              i.structureName = i.loginName = i.linkMan = 'ALL';
              i.submit_type = 'team';
            } else {
              i.submit_type = 'person';
            }

            i.id = i.supUserId || i.supplierId;
            i.salesman_num = i.salesmanNumbs;
            i.link_man = i.linkMan;
            i.link_phone = i.linkPhone;
            return i;
          });
        }
      });
    }

    watch(() => props.modelValue, newVal => {
      var _scroll$value;

      (_scroll$value = scroll.value) === null || _scroll$value === void 0 ? void 0 : _scroll$value.setScrollTop(0);

      if (newVal && !props.editData) {
        var _formRef$value;

        // 新增 重置信息
        // formRef.value?.resetFields();
        form.value = _objectSpread({}, defaultForm);
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        tableData.value = [];
      }

      if (newVal && props.editData) {
        // 编辑查看 初始化信息
        const {
          author,
          content,
          isOpenMessageNotification,
          receiveRange,
          supInformationTypeId,
          title,
          supInformationId,
          receiverList
        } = props.editData;
        tableData.value = receiverList || [];
        initEditData();
        form.value = {
          author,
          supInformationTypeId,
          isOpenMessageNotification,
          receiveRange,
          supInformationId,
          title
        };
      }
    }, {
      flush: 'post'
    });

    function addTeamSuccess(row) {
      tableData.value = arrayRemoveRepeatByProp((tableData.value || []).concat(row), 'id');
      console.log('tableData', tableData.value);
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      tableData.value = tableData.value.filter(row => selectRows.every(select => select.id !== row.id));
    }

    function confirm(status) {
      formRef.value.validate(e => {
        if (e) {
          const payload = _objectSpread(_objectSpread({
            __warn: true,
            __repeat: true
          }, form.value), {}, {
            status
          });

          if (form.value.receiveRange === 2) {
            const receiverList = tableData.value.map(item => {
              // 格式化数据 保证传参一致
              let receiver = {};

              if (item.submit_type === 'team') {
                receiver = {
                  supUserId: item.supUserId || item.sup_user_id,
                  supplierId: item.supplierId || item.supplier_id,
                  type: 1
                };
              } else if (item.submit_type === 'person') {
                receiver = {
                  structureId: item.structureId,
                  supUserId: item.supUserId,
                  supplierId: item.supplierId,
                  type: 3
                };
              }

              return receiver;
            });
            payload.receiverList = receiverList;
          }

          saveNotice(payload).then(data => {
            if (data.success) {
              ElMessage({
                showClose: true,
                message: '操作成功!',
                type: 'success'
              });
              visible.value = false;
              tableData.value = [];
              emit('success');
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.editData ? __props.see ? '查看' : '编辑公告资讯' : '添加公告资讯',
        width: "1050px",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _isRef(visible) ? visible.value = $event : null)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => confirm(2))
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }, 512), [[_vShow, !__props.see]]), _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => confirm(1))
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 512), [[_vShow, !__props.see]])]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "500px",
          style: {
            "padding": "10px",
            "box-sizing": "border-box"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "80px",
            ref_key: "formRef",
            ref: formRef,
            model: form.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "标题",
                  prop: "title",
                  rules: {
                    required: true,
                    message: '请输入标题'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    disabled: __props.see,
                    modelValue: form.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event)
                  }, null, 8, ["disabled", "modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "创建人",
                  prop: "author",
                  rules: {
                    required: true,
                    message: '请输入创建人'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    disabled: __props.see,
                    modelValue: form.value.author,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.author = $event)
                  }, null, 8, ["disabled", "modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 8
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "公告分类",
                  prop: "supInformationTypeId",
                  rules: {
                    required: true,
                    message: '请选择公告分类'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    disabled: __props.see,
                    modelValue: form.value.supInformationTypeId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.supInformationTypeId = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.noticeTypeList, type => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        label: type.text,
                        key: type.id,
                        value: type.id
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "content",
              rules: {
                required: true,
                message: '请输入正文'
              },
              label: "正文"
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(Editor, {
                modelValue: form.value.content,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.content = $event)
              }, null, 8, ["modelValue"]), [[_vShow, !__props.see]]), _withDirectives(_createElementVNode("div", {
                innerHTML: form.value.content
              }, null, 8, _hoisted_1), [[_vShow, __props.see]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "接收团队"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                disabled: __props.see,
                modelValue: form.value.receiveRange,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.receiveRange = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_2]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 2
                }, {
                  default: _withCtx(() => [_hoisted_3]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled", "modelValue"])]),
              _: 1
            }), _withDirectives(_createVNode(_component_vxe_grid, _mergeProps(tableOptions, {
              data: tableData.value,
              ref_key: "table",
              ref: table
            }), {
              tools: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_button, {
                icon: "Plus",
                type: "primary",
                onClick: _cache[5] || (_cache[5] = $event => showAddTeamModal.value = true)
              }, {
                default: _withCtx(() => [_hoisted_4]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Delete",
                type: "danger",
                onClick: del
              }, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              })], 512), [[_vShow, !__props.see]])]),
              _: 1
            }, 16, ["data"]), [[_vShow, form.value.receiveRange === 2]]), _createVNode(_component_el_form_item, {
              label: "是否开启消息面板通知提示",
              "label-width": "180px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                disabled: __props.see,
                modelValue: form.value.isOpenMessageNotification,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.isOpenMessageNotification = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_6]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 0
                }, {
                  default: _withCtx(() => [_hoisted_7]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled", "modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 512), _createVNode(AddTeamModal, {
          modelValue: showAddTeamModal.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showAddTeamModal.value = $event),
          onSuccess: addTeamSuccess
        }, null, 8, ["modelValue"]), _createVNode(AddPersonModal, {
          modelValue: showAddPersonModal.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddPersonModal.value = $event),
          onSuccess: addTeamSuccess
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};